/**
 * Constants for Ticket Dashboard System
 */

// Import theme constants
import { 
  THEME_COLORS, 
  SEMANTIC_COLORS, 
  THEME_CLASSES, 
  COMPONENT_THEMES,
  getStatusThemeClass,
  getButtonThemeClass 
} from './theme';

// Ticket Types
export const TICKET_TYPES = {
  ORDER: 'ORDER',
  REPAIR: 'REPAIR',
  WARRANTY: 'WARRANTY'
};

// Meta Status Types
export const META_STATUS = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING: 'WAITING',
  DONE: 'DONE'
};

// Ticket Type Labels
export const TICKET_TYPE_LABELS = {
  [TICKET_TYPES.ORDER]: 'Order',
  [TICKET_TYPES.REPAIR]: 'Repair',
  [TICKET_TYPES.WARRANTY]: 'Warranty'
};

// Meta Status Labels
export const META_STATUS_LABELS = {
  [META_STATUS.NEW]: 'New',
  [META_STATUS.IN_PROGRESS]: 'In Progress',
  [META_STATUS.WAITING]: 'Waiting',
  [META_STATUS.DONE]: 'Done'
};

// Status Colors (Black and White theme)
export const STATUS_COLORS = {
  [META_STATUS.NEW]: '#1a1a1a',        // Dark gray/almost black
  [META_STATUS.IN_PROGRESS]: '#525252', // Medium gray
  [META_STATUS.WAITING]: '#737373',     // Neutral gray
  [META_STATUS.DONE]: '#9a9a9a'         // Light gray
};

// Default pagination settings
export const PAGINATION_DEFAULTS = {
  PAGE: 1,
  LIMIT: 20,
  MAX_LIMIT: 100
};

// Search debounce delay (ms)
export const SEARCH_DEBOUNCE_DELAY = 300;

// Auto-refresh interval (ms) - 1 minute
export const AUTO_REFRESH_INTERVAL = 60000;

// Filter options for dropdowns
export const FILTER_OPTIONS = {
  TICKET_TYPES: Object.values(TICKET_TYPES),
  META_STATUSES: Object.values(META_STATUS)
};

// Table column keys
export const TABLE_COLUMNS = {
  ID: 'id',
  TICKET_TYPE: 'ticketType',
  CUSTOMER_NAME: 'customerName',
  STAFF_NAME: 'staffName',
  ORDER_ID: 'orderId',
  ORDER_NUMBER: 'orderNumber',
  STORE_NAME: 'storeName',
  CREATED_AT: 'createdAt',
  META_STATUS: 'status.metaStatus',
  ORIGINAL_STATUS: 'status.originalStatus'
};

// Sort directions
export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc'
};

// Default sort configuration
export const DEFAULT_SORT = {
  column: TABLE_COLUMNS.CREATED_AT,
  direction: SORT_DIRECTIONS.DESC
};

// Error messages
export const ERROR_MESSAGES = {
  FETCH_FAILED: 'Failed to fetch tickets. Please try again.',
  EXPORT_FAILED: 'Failed to export data. Please try again.',
  DELETE_FAILED: 'Failed to delete mapping. Please try again.',
  CREATE_FAILED: 'Failed to create mapping. Please try again.',
  UPDATE_FAILED: 'Failed to update mapping. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'Server error. Please try again later.'
};

// Success messages
export const SUCCESS_MESSAGES = {
  EXPORT_SUCCESS: 'Data exported successfully',
  DELETE_SUCCESS: 'Mapping deleted successfully',
  CREATE_SUCCESS: 'Mapping created successfully',
  UPDATE_SUCCESS: 'Mapping updated successfully',
  CACHE_REFRESH_SUCCESS: 'Cache refreshed successfully'
};

// Loading states
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Form validation rules
export const VALIDATION_RULES = {
  
  TICKET_TYPE_REQUIRED: 'Please select a ticket type',
  ORIGINAL_STATUS_REQUIRED: 'Please enter the original status',
  META_STATUS_REQUIRED: 'Please select a meta status'
};




// Chart colors for statistics
export const CHART_COLORS = {
  PRIMARY: '#3B82F6',
  SUCCESS: '#10B981',
  WARNING: '#F59E0B',
  DANGER: '#EF4444',
  INFO: '#06B6D4',
  SECONDARY: '#6B7280'
};






// Animation durations (ms)
export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500
};

// Toast notification types
export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Default values for forms
export const FORM_DEFAULTS = {
  STATUS_MAPPING: {
    ticketType: '',
    originalStatus: '',
    metaStatus: '',
    boardId: ''
  }
};


// Export theme constants
export {
  THEME_COLORS,
  SEMANTIC_COLORS,
  THEME_CLASSES,
  COMPONENT_THEMES,
  getStatusThemeClass,
  getButtonThemeClass
};
